import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { useAuth } from './hooks/useAuth';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { logger } from './services/logger';

import './assets/styles/index.css';

window.addEventListener('error', (event) => {
  logger.error('window.onerror', event.error || event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  logger.error('unhandledrejection', event.reason);
});

// Boot fresco: re-habilita el auto-reload de lazyRetry (routes/index.tsx)
// para el proximo deploy que invalide chunks. Sin esto, un solo reload
// por tab sería suficiente y los siguientes deploys fallarian en silencio.
sessionStorage.removeItem('wiki:chunk-reload');

const initializeAuth = async () => {
  const { fetchUser, refreshUser } = useAuth.getState();
  try {
    // fetchUser: bootstrap inicial desde localStorage
    await fetchUser();
  } catch (error) {
    logger.error('Auth init (fetchUser)', error);
  }
  // refreshUser: re-fetch del backend para obtener los claims actualizados
  // (ej: nuevos departments). Noop si no hay token o falla.
  // Se ejecuta SIEMPRE, incluso si fetchUser arriba funciono, para que
  // el Header del frontend vea el state actual del backend (no el cacheado).
  refreshUser();
};
initializeAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
